import * as React from 'react';
import sanitizeHtml from 'sanitize-html';

const Default = ({ post }) => {
    return (
        <article className="pfa-post-card">
            {!!post.featured_image.length && (
                <figure className="pfa-post-card__image-wrapper" dangerouslySetInnerHTML={{ __html: post.featured_image }} />
            )}
            <div className="pfa-post-card__subtitle" dangerouslySetInnerHTML={{ __html: sanitizeHtml( post.post_type_label ) }}/>
            <h1 className="pfa-post-card__title" dangerouslySetInnerHTML={{ __html: sanitizeHtml( post.post_title ) }} />
            <a href={ post.permalink } className="pfa-post-card__link btn-text">View</a>
        </article>
    )
}

Default.displayName = 'Default';

export default Default;